/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bookings_Meta_DescriptionInputs */

const en_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your lesson bookings and event registrations.`)
};

const es_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra tus reservas de lecciones e inscripciones a eventos.`)
};

const de_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie Ihre Unterrichtsbuchungen und Veranstaltungsanmeldungen.`)
};

const zh_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理你的课程预订和活动注册。`)
};

const ar_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدر حجوزات دروسك وتسجيلات فعالياتك.`)
};

const fr_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez vos réservations de cours et vos inscriptions à des événements.`)
};

const vi_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý lịch đặt buổi học và đăng ký sự kiện của bạn.`)
};

const sw_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dhibiti nafasi za masomo ulizoweka na usajili wa matukio.`)
};

const th_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดการการจองบทเรียนและการลงทะเบียนกิจกรรมของคุณ`)
};

const bs_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravljajte rezervacijama lekcija i prijavama na događaje.`)
};

const ja_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンの予約とイベントの登録を管理できます。`)
};

const ko_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수업 예약과 이벤트 등록을 관리하세요.`)
};

const pt_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerencie suas reservas de aulas e inscrições de eventos.`)
};

const it_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci le tue prenotazioni di lezioni e le registrazioni degli eventi.`)
};

const sv_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantera dina lektionsbokningar och evenemangsregistreringar.`)
};

const nl_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer je lesboekingen en inschrijvingen voor evenementen.`)
};

const da_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer dine lektionsbookinger og tilmeldinger til arrangementer.`)
};

const nb_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer timebestillingene og arrangementspåmeldingene dine.`)
};

const fi_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallitse tuntivarauksiasi ja tapahtumailmoittautumisiasi.`)
};

const pl_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj rezerwacjami lekcji i zapisami na wydarzenia.`)
};

const ru_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управляйте записями на уроки и регистрациями на мероприятия.`)
};

const tr_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders rezervasyonlarınızı ve etkinlik kayıtlarını yönetin.`)
};

const hi_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी पाठ बुकिंग और कार्यक्रम पंजीकरण प्रबंधित करें।`)
};

const id_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola pemesanan pelajaran dan pendaftaran acara Anda.`)
};

const ms_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urus tempahan pelajaran dan pendaftaran acara anda.`)
};

const cs_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spravujte své rezervace lekcí a registrace na akce.`)
};

const el_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διαχειριστείτε τις κρατήσεις μαθημάτων και τις εγγραφές σας σε εκδηλώσεις.`)
};

const he_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נהלו את הזמנות השיעורים וההרשמות לאירועים שלכם.`)
};

const af_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestuur jou lesbesprekings en geleentheidsregistrasies.`)
};

const hu_bookings_meta_description = /** @type {(inputs: Bookings_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezeld az órafoglalásaidat és az eseményekre való jelentkezéseidet.`)
};

/**
* | output |
* | --- |
* | "Manage your lesson bookings and event registrations." |
*
* @param {Bookings_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const bookings_meta_description = /** @type {((inputs?: Bookings_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bookings_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_bookings_meta_description(inputs)
	if (locale === "de") return de_bookings_meta_description(inputs)
	if (locale === "zh") return zh_bookings_meta_description(inputs)
	if (locale === "ar") return ar_bookings_meta_description(inputs)
	if (locale === "fr") return fr_bookings_meta_description(inputs)
	if (locale === "vi") return vi_bookings_meta_description(inputs)
	if (locale === "sw") return sw_bookings_meta_description(inputs)
	if (locale === "th") return th_bookings_meta_description(inputs)
	if (locale === "bs") return bs_bookings_meta_description(inputs)
	if (locale === "ja") return ja_bookings_meta_description(inputs)
	if (locale === "ko") return ko_bookings_meta_description(inputs)
	if (locale === "pt") return pt_bookings_meta_description(inputs)
	if (locale === "it") return it_bookings_meta_description(inputs)
	if (locale === "sv") return sv_bookings_meta_description(inputs)
	if (locale === "nl") return nl_bookings_meta_description(inputs)
	if (locale === "da") return da_bookings_meta_description(inputs)
	if (locale === "nb") return nb_bookings_meta_description(inputs)
	if (locale === "fi") return fi_bookings_meta_description(inputs)
	if (locale === "pl") return pl_bookings_meta_description(inputs)
	if (locale === "ru") return ru_bookings_meta_description(inputs)
	if (locale === "tr") return tr_bookings_meta_description(inputs)
	if (locale === "hi") return hi_bookings_meta_description(inputs)
	if (locale === "id") return id_bookings_meta_description(inputs)
	if (locale === "ms") return ms_bookings_meta_description(inputs)
	if (locale === "cs") return cs_bookings_meta_description(inputs)
	if (locale === "el") return el_bookings_meta_description(inputs)
	if (locale === "he") return he_bookings_meta_description(inputs)
	if (locale === "af") return af_bookings_meta_description(inputs)
	if (locale === "hu") return hu_bookings_meta_description(inputs)
	return en_bookings_meta_description(inputs)
});